import {
  ShopConfigResponse,
  ShopConfigResponseSchema,
  UpdateShopLogisticsRequest,
  UpdateShopLogisticsRequestSchema,
} from "@codway-dev/shared";
import { AuthService } from "./auth.service";

const API_BASE_URL = "/api";

export const ShippingService = {
  getLogistics: async (): Promise<ShopConfigResponse> => {
    const token = await AuthService.getShopifyToken();
    if (!token) throw new Error("No Shopify token available");

    const response = await fetch(`${API_BASE_URL}/admin/shop/logistics`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to load shipping config: ${response.statusText}`);
    }

    const data = await response.json();
    return ShopConfigResponseSchema.parse(data);
  },

  updateLogistics: async (
    data: UpdateShopLogisticsRequest
  ): Promise<ShopConfigResponse> => {
    const token = await AuthService.getShopifyToken();
    if (!token) throw new Error("No Shopify token available");

    const validPayload = UpdateShopLogisticsRequestSchema.parse(data);

    const response = await fetch(`${API_BASE_URL}/admin/shop/logistics`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(validPayload),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(
        `Failed to save shipping config: ${errorData.message || response.statusText}`
      );
    }

    const result = await response.json();
    return ShopConfigResponseSchema.parse(result);
  },
};
